import SignupPage from './SignupPageFrontend';

export default SignupPage;
